import { useEffect } from "react";
import { PAGE_EXPERIMENT_PDP_COMPARISON_TABLE } from "@shared/utils.experimentation";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";
import { dispatch } from "@shared/utils.events";
import { getComparisonData } from "@growth/page.products";
import { useLocale } from "hooks";

type UseProductComparisonProps = {
  pdpComparisonTableExperimentValue?: number;
  slug: string;
};

type UseProductComparisonReturn = {
  shouldRenderComparison: boolean;
  onComparisonTableViewed: () => void;
  onComparisonTableScrolled?: () => void;
};

export const useProductComparison = ({
  pdpComparisonTableExperimentValue,
  slug
}: UseProductComparisonProps): UseProductComparisonReturn => {
  const trackExperimentViewed = useExperimentViewed();
  const locale = useLocale();
  const comparisonData = getComparisonData(slug, locale);

  const shouldRenderComparison = Boolean(
    comparisonData &&
      pdpComparisonTableExperimentValue !== undefined &&
      pdpComparisonTableExperimentValue !== null &&
      [
        PAGE_EXPERIMENT_PDP_COMPARISON_TABLE.values.VARIANT,
        PAGE_EXPERIMENT_PDP_COMPARISON_TABLE.values.THROWAWAY_VARIANT
      ].includes(Number(pdpComparisonTableExperimentValue))
  );

  useEffect(() => {
    if (
      !comparisonData ||
      pdpComparisonTableExperimentValue === undefined ||
      pdpComparisonTableExperimentValue === null
    )
      return;

    if (
      [
        PAGE_EXPERIMENT_PDP_COMPARISON_TABLE.values.VARIANT,
        PAGE_EXPERIMENT_PDP_COMPARISON_TABLE.values.CONTROL
      ].includes(Number(pdpComparisonTableExperimentValue))
    ) {
      trackExperimentViewed(
        PAGE_EXPERIMENT_PDP_COMPARISON_TABLE.name,
        pdpComparisonTableExperimentValue
      );
    }
  }, [
    comparisonData,
    trackExperimentViewed,
    pdpComparisonTableExperimentValue
  ]);

  const onComparisonTableScrolled = () => {
    dispatch("page element clicked", {
      target: "Comparison Table Scrolled",
      details: "Scroll performed",
      location: "PDP"
    });
  };

  const onComparisonTableViewed = () => {
    dispatch("page element viewed", {
      target: "Comparison Table",
      location: "PDP"
    });
  };

  return {
    shouldRenderComparison,
    onComparisonTableViewed,
    onComparisonTableScrolled
  };
};
